<!--
 * @Author: 王伟 623353546@qq.com
 * @Date: 2023-09-16 12:50:31
 * @LastEditors: 王伟 623353546@qq.com
 * @LastEditTime: 2023-09-28 09:19:15
 * @FilePath: \hrc_shop_v3\src\components\Nav\Nav.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="Nav">
    <router-link  class="nav-item" to="/goods" >
    商品
    <i class="line"></i>
    </router-link>
    <!-- <router-link v-if="pickup == '1'" class="nav-item" to="/pinkup" >
    取货码
    <i class="line"></i>
    </router-link> -->
    <router-link class="nav-item" to="/seller" >
    客服<span>( {{ show }} )</span>
    <i class="line"></i>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      show: ''
    }
  },
  props:['commentNum','imei','server_url','pickup'],
  created(){
    this.show = this.imei.slice(-6)
  }
}
</script>


<style scoped>
.Nav{
    display:flex;
    widows: 100%;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #e4e4e4
}
.nav-item{
   flex: 1;
   text-align: center;
   font-size: 13px;
   text-decoration: none;
   color: #666666;
   position: relative;
}
.Nav .active{
    color: #ffbb22;
}
.Nav .active .line{
    width: 20px;
    height: 2px;
    display: inline-block;
    background-color: #ffbb22;
    position: absolute;
    left:50%;
    bottom: 0;
    margin-left: -10px;

}
</style>


// WEBPACK FOOTER //
// src/components/Nav/Nav.vue